import { defineComponent as _defineComponent } from 'vue'
import { useKennelCount } from '@/store/kennelCounts';
import { Dogspaces, Kennels } from '@busy-human/k9-library';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { isEqual } from 'lodash';
import BulkEdit from './bulk-edit.vue';
import { events } from '@/events';
import { Temporal } from 'temporal-polyfill';

type Emits = {
	(e: 'close'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'kennel-count-modal',
  props: {
    date: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const kennelStore = useKennelCount();

const storeKey = computed(() => kennelStore.kennelCountKey(props.date.year, props.date.month+1, props.date.day));

const bulkEdit = ref<null | Dogspaces.Sizes>(null);

const givenCounts = ref(Kennels.Collection.defaults().kennelCount);
const givenMax = ref(Kennels.Collection.defaults().kennelCount);

function loadCounts() {
	givenCounts.value = {...(kennelStore.kennelCount.get(storeKey.value) || Kennels.Collection.defaults().kennelCount)};
	givenMax.value = {...(kennelStore.kennelMax.get(storeKey.value) || Kennels.Collection.defaults().kennelCount)};
}

onMounted(() => events.on("kennel:reload", loadCounts));
onUnmounted(() => events.off("kennel:reload", loadCounts));

watch(() => props.date, () => {
	loadCounts();
}, {immediate: true});

const hasChanged = computed(() => {
	const currentCounts = kennelStore.kennelCount.get(storeKey.value) || Kennels.Collection.defaults().kennelCount;
	const currentMax = kennelStore.kennelMax.get(storeKey.value) || Kennels.Collection.defaults().kennelCount;

	return (!isEqual(currentCounts, givenCounts.value) || !isEqual(currentMax, givenMax.value));
});

const emit = __emit;

async function doUpdate() {
	await kennelStore.adjustKennelCounts(
		kennelStore.kennelCountKey(props.date.year, props.date.month+1, props.date.day),
		givenCounts.value,
		givenMax.value
	);
	emit('close');
	events.emit("kennel:reload");
}


const __returned__ = { props, kennelStore, storeKey, bulkEdit, givenCounts, givenMax, loadCounts, hasChanged, emit, doUpdate, get useKennelCount() { return useKennelCount }, get Dogspaces() { return Dogspaces }, get Kennels() { return Kennels }, computed, onMounted, onUnmounted, ref, watch, get isEqual() { return isEqual }, BulkEdit, get events() { return events }, get Temporal() { return Temporal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})